import { Image } from '@domain-group/suit-theme'

interface WatermarkProps {
  watermarkImageUrl: string,
  watermarkSettings: {
    height: number,
    horizontal: number,
    opacity: number,
    position: string,
    vertical: number,
    width: number,
  },
}

const Watermark = (props: WatermarkProps) => {
  const {
    watermarkImageUrl, watermarkSettings,
  } = props

  const {
    height,
    horizontal,
    opacity,
    position,
    vertical,
    width,
  } = watermarkSettings || {}

  return (
    <Image
      backgroundSize="contain"
      boxProps={{
        backgroundImage: `url(${watermarkImageUrl})`,
        bottom: position.includes('south') ? `${vertical}px` : null,
        height,
        left: position.includes('west') ? `${horizontal}px` : null,
        maxHeight: [100, '100%'],
        maxWidth: [100, '100%'],
        opacity,
        position: 'absolute',
        right: position.includes('east') ? `${horizontal}px` : null,
        top: position.includes('north') ? `${vertical}px` : null,
        width,
        zIndex: 1,
      }}
    />
  )
}

export default Watermark
